import fetch from 'auth/FetchInterceptor'

const userService = {}

userService.getUser = function (params) {
  return fetch({
    url: '/users/',
    method: 'get', 
    params 
  })
}

userService.getUserById = function (params) {
  return fetch({
    url: `/users/${params.userId}`,
    method: 'get'
  })
}

userService.updateUser = function (data, params) {
  return fetch({
    url: `/users/${params.userId}`,
    method: 'put',
    data
  })
}
userService.patchUser = function (data, params) {
  return fetch({
    url: `/users/${params.userId}`,
    method: 'patch',
    data
  })
}


userService.createUser = function (data) {
  const sendAutoEmail = data.notifyAutoMail ? data.notifyAutoMail : false;
     delete data.notifyAutoMail;
  return fetch({
    url: `/users?notifyAutoMail=${sendAutoEmail}`,
    method: 'post',
    data
  })
}
userService.createVerifier = function (data) {
  return fetch ({
    url: '/users/verifier',
    method: 'post',
    data
  })
}

userService.createUserCsv = function (data) {
  return fetch({
    url: '/users/csv',
    method: 'post',
    data
  })
}
userService.createVerifierCsv = function (data) {
  return fetch({
    url: '/users/verifier/csv',
    method: 'post',
    data
  })
}

userService.deleteUser = function (params) {
  return fetch({
    url: `/users/${params.userId}`,
    method: 'delete',
  })
}
userService.deleteVerifier = function (params) {
  let url = `/users/verifier/${params.userId}?changeVerifierEmail=${params.changeVerifierEmail}`
  return fetch ({
    url: url,
    method: 'delete'
  })
}


userService.createAccess = function (data) {
  return fetch({
    url: '/accessControl/',
    method: 'post',
    data
  })
}

userService.updateAccess = function (data, params) {
  return fetch({
    url: `/accessControl/${params.accessId}`,
    method: 'put',
    data
  })
}


userService.getAccess = function (params) {
  return fetch({
    url: '/accessControl/',
    method: 'get',
    params
  })
}

userService.getAllUserAccess = function (userId) {
  return fetch({
    url: `/accessControl/user-access/${userId}`,
    method: 'get'
  })
}

userService.createSecondaryAdmin = function (data) {
  return fetch({
    url: `/users/secondaryAdmin`,
    method: 'post',
    data
  })
}

userService.deleteSecondaryAdmin = function (params) {
  return fetch ({
    url: `/users/secondaryAdmin/${params.id}`,
    method: 'delete'
  })
}


export default userService